module.exports = __webpack_public_path__ + "img/14.0e7260b2.jpg";